<template>
  <div class="container clearfix">
    <video
      class="video"
      src="../../assets/PC官网高分辨率.mp4"
      autoplay
      loop
      muted
    ></video>
    <!-- <tabBar class="head"></tabBar> -->

    <div class="main">
      <div class="update" @click="update">
        <div class="update_img"></div>
        <div class="update_text">上传新作品</div>
      </div>
      <div class="product" @click="product">
        <div class="product_img"></div>
        <div class="product_text">查看我的作品库</div>
      </div>
    </div>
    <div class="model"></div>
  </div>
</template>
<script>
/* eslint-disable */
import tabBar from "../components/tabBar";
export default {
  components: { tabBar },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    product() {
      this.$router.push({ path: "/product" });
    },
    update() {
      this.$router.push({ path: "/update" });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow: hidden;

  .video {
    object-fit: fill;
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .head {
    position: relative;
    z-index: 99;
  }
  .main {
    width: 610px;
    height: 240px;
    position: relative;
    margin: 200px auto;
    z-index: 999;
    .update {
      width: 240px;
      height: 240px;
      width: 240px;
      height: 240px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 10px;
      float: left;
      cursor: pointer;

      .update_img {
        width: 108px;
        height: 123px;
        margin: 37px auto 25px;
        background: url("../../assets/jlt_pc.png") no-repeat;
        background-size: 535px 314px;
        background-position: -29px -157px;
        // 170 167
      }
      .update_text {
        text-align: center;
        font-size: 18px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: rgba(254, 255, 254, 1);
      }
    }
    .product {
      width: 240px;
      height: 240px;
      width: 240px;
      height: 240px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 10px;
      float: right;
      cursor: pointer;
      .product_img {
        width: 132px;
        height: 103px;
        margin: 42px auto 40px;
        background: url("../../assets/jlt_pc.png") no-repeat;
        background-size: 535px 314px;
        background-position: -170px -167px;
      }
      .product_text {
        text-align: center;
        font-size: 18px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: rgba(254, 255, 254, 1);
      }
    }
  }
}
.model {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 1);
  opacity: 0.6;
  position: absolute;
  z-index: 9;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue